<template>
  <j-modal :title="title" :width="width" :visible="visible" switchFullscreen @ok="handleOk" @okButton="okButton"
    :ok-disabled="disableSubmit" :okButtonProps="{ class: { 'jee-hidden': disableSubmit } }" @cancel="handleCancel"
    cancelText="关闭">
    <PersonSelectedForm ref="realForm" @ok="submitCallback" :disabled="disableSubmit"></PersonSelectedForm>
  </j-modal>
</template>

<script>

import PersonSelectedForm from './PersonSelectedForm.vue'

export default {
  name: 'PersonSelectedModal',
  components: {
    PersonSelectedForm
  },
  data() {
    return {
      title: '',
      width: 800,
      visible: false,
      disableSubmit: true
    }
  },
  methods: {

    okButton(res) {

      //确定是否显示表单的确认按钮
      this.disable = this.disableSubmit
    },
    add() {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.realForm.add();
      })
    },
    edit(record) {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.realForm.edit(record);
      })
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      this.$refs.realForm.submitForm();
    },
    submitCallback() {
      this.$emit('ok');
      this.visible = false;
    },
    handleCancel() {
      this.close()
    }
  }
}
</script>